(function () {
  var TIERS = [
    { minQty: 4, percent: 20, label: "BUY 4 GET 20% OFF", code: "BUY4" },
    { minQty: 3, percent: 15, label: "BUY 3 GET 15% OFF", code: "BUY3" },
    { minQty: 2, percent: 10, label: "BUY 2 GET 10% OFF", code: "BUY2" },
  ];
  var TAG =
    '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 2.5h6.2L14 7.8a1.5 1.5 0 0 1 0 2.1l-4.1 4.1a1.5 1.5 0 0 1-2.1 0L2.5 8.7V2.5Zm3.1 3.2a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z"/></svg>';
  var TRASH =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m1 0v12a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V7h10Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var root = document.getElementById("alb-cart");
  if (!root) return;
  if (root.parentNode !== document.body) document.body.appendChild(root);
  document.body.classList.add("alb-cart-ready");

  var titleEl = root.querySelector("#alb-cart-title");
  var bannerEl = root.querySelector("[data-alb-banner]");
  var bodyEl = root.querySelector("[data-alb-body]");
  var footerEl = root.querySelector("[data-alb-footer]");
  var summaryEl = root.querySelector("[data-alb-summary]");
  var checkoutBtn = root.querySelector("[data-alb-checkout]");
  var productCache = {};
  var cart = { items: [], item_count: 0, total_price: 0, total_discount: 0 };
  var busy = false;
  var lastTier = null;
  var shopifyDiscounted = false;

  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function displayTitle(title) {
    var t = String(title || "");
    var i = t.lastIndexOf("|");
    return (i === -1 ? t : t.slice(i + 1)).trim();
  }

  function money(cents) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    }).format((Number(cents) || 0) / 100);
  }

  function summarize(items) {
    var count = 0;
    var subtotal = 0;
    items.forEach(function (item) {
      count += item.quantity;
      subtotal += item.final_line_price || item.line_price || 0;
    });
    var tier = TIERS.find(function (t) {
      return count >= t.minQty;
    }) || null;
    var discount = tier ? Math.floor((subtotal * tier.percent) / 100) : 0;
    return { count: count, subtotal: subtotal, discount: discount, total: subtotal - discount, tier: tier };
  }

  function productFor(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch("/products/" + handle + ".js")
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
    return productCache[handle];
  }

  function variantMeta(product, variantId) {
    if (!product || !product.variants) return null;
    return (
      product.variants.find(function (v) {
        return String(v.id) === String(variantId);
      }) || null
    );
  }

  function openDrawer() {
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("alb-cart-lock");
    var closeBtn = root.querySelector(".alb-cart__close");
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("alb-cart-lock");
  }

  function setCountBadge(n) {
    document.querySelectorAll("[data-alb-cart-count], .bh__count").forEach(function (el) {
      if (n > 0) {
        el.hidden = false;
        el.removeAttribute("hidden");
        el.textContent = String(n);
      } else {
        el.hidden = true;
        el.setAttribute("hidden", "");
      }
    });
  }

  function emptyHtml() {
    return (
      '<div class="alb-cart__empty">' +
      "<h3>Your bag is empty</h3>" +
      "<p>Free UK delivery and extra savings when you buy more than one piece.</p>" +
      '<a class="alb-cart__empty-btn" href="/collections/all">Continue shopping</a>' +
      "</div>"
    );
  }

  function lineHtml(item, meta) {
    var title = displayTitle(item.product_title || item.title);
    var qty = item.quantity;
    var now = item.final_line_price || item.line_price || 0;
    var compare = meta && meta.compare_at_price ? Number(meta.compare_at_price) : 0;
    var was = compare > (item.price || 0) ? compare * qty : 0;
    var variant =
      item.variant_title && item.variant_title.toLowerCase() !== "default title"
        ? '<p class="alb-cart__variant">' + esc(item.variant_title) + "</p>"
        : "";
    var img =
      (item.image && (item.image.indexOf("http") === 0 ? item.image : item.featured_image && item.featured_image.url)) ||
      (item.featured_image && (item.featured_image.url || item.featured_image.src)) ||
      "";
    if (!img && item.image) img = item.image;
    return (
      '<li class="alb-cart__line" data-key="' +
      esc(item.key) +
      '">' +
      '<a class="alb-cart__thumb" href="' +
      esc(item.url || "/products/" + item.handle) +
      '">' +
      (img ? '<img src="' + esc(img) + '" alt="">' : "") +
      "</a>" +
      '<div class="alb-cart__info">' +
      '<div class="alb-cart__row-top">' +
      '<a class="alb-cart__name" href="' +
      esc(item.url || "/products/" + item.handle) +
      '">' +
      esc(title) +
      "</a>" +
      '<button type="button" class="alb-cart__remove" data-alb-remove="' +
      esc(item.key) +
      '" aria-label="Remove ' +
      esc(title) +
      '">' +
      TRASH +
      "</button>" +
      "</div>" +
      variant +
      '<div class="alb-cart__prices">' +
      (was ? '<s class="alb-cart__was">' + money(was) + "</s>" : "") +
      '<span class="alb-cart__now' +
      (was ? "" : " is-regular") +
      '">' +
      money(now) +
      "</span>" +
      "</div>" +
      '<div class="alb-cart__qty">' +
      '<button type="button" data-alb-qty="' +
      esc(item.key) +
      '" data-delta="-1" aria-label="Decrease quantity"' +
      (qty <= 1 ? " disabled" : "") +
      ">−</button>" +
      "<span>" +
      qty +
      "</span>" +
      '<button type="button" data-alb-qty="' +
      esc(item.key) +
      '" data-delta="1" aria-label="Increase quantity">+</button>' +
      "</div></div></li>"
    );
  }

  function render(metaByVariant) {
    var totals = summarize(cart.items || []);
    lastTier = totals.tier;
    var shopifyOff = Number(cart.total_discount || 0);
    shopifyDiscounted = shopifyOff > 0;
    var discount = shopifyOff > 0 ? shopifyOff : totals.discount;
    var total = shopifyOff > 0 ? cart.total_price : totals.total;
    var count = cart.item_count || totals.count;
    if (titleEl) titleEl.textContent = "Your bag (" + count + " items)";
    setCountBadge(count);

    var last = (cart.items || []).some(function (item) {
      var meta = metaByVariant[String(item.variant_id)];
      return meta && Number(meta.inventory_quantity) === 1;
    });
    if (bannerEl) bannerEl.hidden = !(last && count > 0);

    if (!count) {
      bodyEl.innerHTML = emptyHtml();
      footerEl.hidden = true;
      return;
    }

    bodyEl.innerHTML =
      '<ul class="alb-cart__lines">' +
      (cart.items || [])
        .map(function (item) {
          return lineHtml(item, metaByVariant[String(item.variant_id)]);
        })
        .join("") +
      "</ul>";

    var rows = "";
    if (totals.tier && discount > 0) {
      rows +=
        '<div class="alb-cart__row"><div class="alb-cart__discount-side"><span class="alb-cart__tag">' +
        TAG +
        esc(totals.tier.label) +
        '</span></div><span class="alb-cart__discount-amt">− ' +
        money(discount) +
        "</span></div>";
    }
    rows +=
      '<div class="alb-cart__row"><span>Delivery</span><strong>FREE</strong></div>' +
      '<div class="alb-cart__row alb-cart__row--total"><span>Total</span><span>' +
      money(total) +
      "</span></div>";
    summaryEl.innerHTML = rows;
    footerEl.hidden = false;
  }

  function loadCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        cart = data;
        var handles = [];
        (data.items || []).forEach(function (item) {
          if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });
        return Promise.all(handles.map(productFor)).then(function (products) {
          var metaByVariant = {};
          products.forEach(function (product) {
            if (!product || !product.variants) return;
            product.variants.forEach(function (v) {
              metaByVariant[String(v.id)] = v;
            });
          });
          render(metaByVariant);
        });
      })
      .catch(function () {
        bodyEl.innerHTML =
          '<div class="alb-cart__empty"><h3>Couldn’t load your bag</h3><p>Refresh the page and try again.</p></div>';
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  function addItem(id, quantity) {
    if (busy) return Promise.resolve();
    busy = true;
    return post("/cart/add.js", { items: [{ id: Number(id), quantity: quantity || 1 }] })
      .then(function () {
        return loadCart();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function () {
        return loadCart();
      })
      .finally(function () {
        busy = false;
      });
  }

  function changeItem(key, quantity) {
    if (busy) return;
    busy = true;
    post("/cart/change.js", { id: key, quantity: quantity })
      .then(function () {
        return loadCart();
      })
      .finally(function () {
        busy = false;
      });
  }

  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-alb-close]")) {
      closeDrawer();
      return;
    }
    var emptyBtn = e.target.closest(".alb-cart__empty-btn");
    if (emptyBtn) closeDrawer();
    var remove = e.target.closest("[data-alb-remove]");
    if (remove) {
      e.preventDefault();
      changeItem(remove.getAttribute("data-alb-remove"), 0);
      return;
    }
    var qty = e.target.closest("[data-alb-qty]");
    if (qty) {
      e.preventDefault();
      var current = (cart.items || []).find(function (item) {
        return item.key === qty.getAttribute("data-alb-qty");
      });
      if (!current) return;
      var next = current.quantity + Number(qty.getAttribute("data-delta"));
      if (next < 1) return;
      changeItem(qty.getAttribute("data-alb-qty"), next);
    }
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function () {
      if (lastTier && !shopifyDiscounted) {
        window.location.href =
          "/discount/" + lastTier.code + "?redirect=" + encodeURIComponent("/checkout");
        return;
      }
      window.location.href = "/checkout";
    });
  }

  document.addEventListener(
    "click",
    function (e) {
      var opener = e.target.closest("[data-alb-open-cart], [aria-controls='cart-drawer']");
      if (opener && !opener.closest("#alb-cart")) {
        e.preventDefault();
        e.stopPropagation();
        loadCart().then(openDrawer);
        return;
      }
      var cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"]');
      if (cartLink && !cartLink.closest("#alb-cart") && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        loadCart().then(openDrawer);
      }
    },
    true,
  );

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = (form.getAttribute("action") || "").toLowerCase();
      if (!form.classList.contains("bpd__form") && action.indexOf("/cart/add") === -1) return;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addItem(idInput.value, qty);
    },
    true,
  );

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("is-open")) closeDrawer();
  });

  var skipWatch = 0;
  function watched(fn) {
    skipWatch += 1;
    return fn().finally(function () {
      skipWatch -= 1;
    });
  }
  var origPost = post;
  post = function (url, body) {
    return watched(function () {
      return origPost(url, body);
    });
  };
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    return origFetch.apply(this, arguments).then(function (res) {
      if (!res || !res.ok || skipWatch) return res;
      if (url.indexOf("/cart/add") !== -1) {
        loadCart().then(openDrawer);
      } else if (url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1) {
        loadCart();
      }
      return res;
    });
  };

  loadCart();
})();
